export default __webpack_public_path__ + "static/media/intro.5241af14.png";